import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// In project imports
import Home from './pages/home.js';
import Products from './pages/products.js';
import About from './pages/about.js';
import Contact from './pages/contact.js';
import Catalogs from './pages/catalogs.js';

import NavBar from './components/NavBar.js';
import InfoBar from './components/InfoBar.js';

// @mui material components
import {  createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";




const App = () => {
  const defaultTheme = createTheme({
    palette: {
      primary: {
        main: '#ff9100',
      },
      secondary: {
        main: '#edf2ff',
      },
    },
    typography: {
      fontFamily: [
        'Roboto', // Default for English
        'Noto Sans Thai', // Fallback for Thai
        'Arial',
        'sans-serif',
      ].join(','),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ':lang(th)': { // Applies when `lang="th"` is set
            fontFamily: 'Noto Sans Thai, Roboto, sans-serif',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Router>
        <div>
          <NavBar />
          <InfoBar />
                   
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/catalogs" element={<Catalogs />} />
            <Route path="*" element={<Home />} /> {/* Fallback to Home for unknown routes */}
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
